module.exports = __webpack_public_path__ + "img/add_btn_icon471.c4e19da3.svg";